import React from "react";
import { func, string } from "prop-types";

const Image = ({ className, onError, src, alt }) => (
    <img className={className} src={src} onError={onError} alt={alt} />
);

Image.propTypes = {
    onError: func,
    className: string,
    src: string,
    alt: string
};

Image.defaultProps = {
    src: "/images/image-not-found.png",
    onError: e => {
        e.target.src = "/images/image-not-found.png";
    },
    className: "",
    alt: ""
};

export default Image;
